// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-scroll';
import { FaInstagram, FaFacebook, FaWhatsapp, FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';

const quickLinks = ['Home', 'About', 'Services', 'Contact'];
const topServices = [
  'Individual Counseling',
  'Anxiety & Depression Counseling',
  'Couple Counseling',
  'Children & Adolescent Counseling',
  'Stress Management Counseling',
  'Career Guidance Counseling',
];

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.grid}>
          {/* Column 1: Brand */}
          <div style={styles.col}>
            <div style={styles.brandRow}>
              <span>
                <img src="Logo.png" alt="Brain Icon" style={{ width: 'auto', height: 36 }} />
              </span>
              <div>
                <div style={styles.brandName}>VIHA MindCare</div>
                <div style={styles.brandSub}>Psychology Centre</div>
              </div>
            </div>
            <p style={styles.brandTagline}>
              "Healing Minds, Empowering Lives."
            </p>
            <div style={styles.socialRow}>
              {[
                { icon: <FaInstagram />, href: '#', label: 'Instagram', color: '#E1306C' },
                { icon: <FaFacebook />,  href: '#', label: 'Facebook',  color: '#1877F2' },
                // { icon: <FaWhatsapp />,  href: 'https://wa.me/9420085453', label: 'WhatsApp', color: '#25D366' },
                { icon: <FaWhatsapp />,  href: 'https://wa.me/9004910709', label: 'WhatsApp', color: '#25D366' },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.label}
                  style={styles.socialIcon}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div style={styles.col}>
            <h4 style={styles.colTitle}>Quick Links</h4>
            <ul style={styles.linkList}>
              {quickLinks.map((link) => (
                <li key={link}>
                  <Link
                    to={link.toLowerCase()}
                    smooth={true}
                    duration={600}
                    offset={-80}
                    style={styles.link}
                  >
                    › {link}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="contact" smooth={true} duration={600} offset={-80} style={styles.link}>
                  › Book a Session
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Services */}
          <div style={styles.col}>
            <h4 style={styles.colTitle}>Our Services</h4>
            <ul style={styles.linkList}>
              {topServices.map((svc) => (
                <li key={svc}>
                  <Link to="services" smooth={true} duration={600} offset={-80} style={styles.link}>
                    › {svc}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div style={styles.col}>
            <h4 style={styles.colTitle}>Contact Us</h4>
            <ul style={styles.contactList}>
              <li style={styles.contactItem}>
                <FaMapMarkerAlt style={styles.contactIcon} />
                <span>VIHA MindCare Psychology Centre, Shop No.9, Plot No.42/43, Ground Floor, Surya Darshan Residency, Sector-20, Kamothe, Panvel, Navi Mumbai - 410209</span>
              </li>
              <li style={styles.contactItem}>
                <FaPhone style={styles.contactIcon} />
                {/* <a href="tel:+919420085453" style={styles.contactLink}>+91 9420085453</a> */}
                <a href="tel:+919004910709" style={styles.contactLink}>+91 9004910709</a>
              </li>
              <li style={styles.contactItem}>
                <FaEnvelope style={styles.contactIcon} />
                <a href="mailto:vihamindcare@gmail.com" style={styles.contactLink}>vihamindcare@gmail.com</a>
              </li>
              <li style={styles.contactItem}>
                <FaClock style={styles.contactIcon} />
                <span>Mon – Sat, 9 AM – 7 PM</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={styles.bottomBar}>
          <p style={styles.copyright}>
            © {new Date().getFullYear()} VIHA MindCare Psychology Centre. All Rights Reserved.
          </p>
          <p style={styles.bottomNote}>
            Designed with 💚 for mental wellness in Pune.
          </p>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: '#1B3F6E',
    color: '#B8D4F0',
    paddingTop: 64,
  },
  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 24px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: 40,
    paddingBottom: 48,
    borderBottom: '1px solid rgba(214,232,247,0.15)',
  },
  col: {},
  brandRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 16,
  },
  brandName: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 18,
    fontWeight: 700,
    color: '#ffffff',
    lineHeight: 1.2,
  },
  brandSub: {
    fontFamily: "'Lato', sans-serif",
    fontSize: 11,
    fontWeight: 600,
    color: '#5A9E4B',
    textTransform: 'uppercase',
    letterSpacing: 1.5,
  },
  brandTagline: {
    fontFamily: "'Playfair Display', serif",
    fontStyle: 'italic',
    fontSize: 14,
    color: '#B8D4F0',
    lineHeight: 1.6,
    marginBottom: 24,
  },
  socialRow: {
    display: 'flex',
    gap: 12,
  },
  socialIcon: {
    width: 38,
    height: 38,
    borderRadius: '50%',
    backgroundColor: 'rgba(255,255,255,0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: 16,
    textDecoration: 'none',
    transition: 'background 0.25s ease, transform 0.25s ease',
  },
  colTitle: {
    fontFamily: "'Lato', sans-serif",
    fontSize: 13,
    fontWeight: 700,
    color: '#ffffff',
    textTransform: 'uppercase',
    letterSpacing: 2,
    marginBottom: 20,
    paddingBottom: 10,
    borderBottom: '2px solid #5A9E4B',
    display: 'inline-block',
  },
  linkList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  link: {
    fontFamily: "'Lato', sans-serif",
    fontSize: 14,
    color: '#B8D4F0',
    cursor: 'pointer',
    transition: 'color 0.2s ease',
    textDecoration: 'none',
  },
  contactList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
  },
  contactItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    fontFamily: "'Lato', sans-serif",
    fontSize: 14,
    color: '#B8D4F0',
    lineHeight: 1.5,
  },
  contactIcon: {
    color: '#5A9E4B',
    fontSize: 15,
    marginTop: 2,
    flexShrink: 0,
  },
  contactLink: {
    color: '#B8D4F0',
    textDecoration: 'none',
    transition: 'color 0.2s ease',
  },
  bottomBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 8,
    padding: '20px 0',
  },
  copyright: {
    fontFamily: "'Lato', sans-serif",
    fontSize: 13,
    color: '#7A9BB8',
    margin: 0,
  },
  bottomNote: {
    fontFamily: "'Lato', sans-serif",
    fontSize: 13,
    color: '#7A9BB8',
    margin: 0,
  },
};

export default Footer;
